(() => {
if (window.__staffStylingIndex) return;
window.__staffStylingIndex = true;
let shared;
const parse = html => new DOMParser().parseFromString(html, 'text/html');
async function read(url) {
 const response = await fetch(url, {credentials:'same-origin', signal:AbortSignal.timeout(12000)});
 if (!response.ok) throw new Error('Styling could not be loaded');
 return parse(await response.text());
}
function themed(path, theme) {
 const url = new URL(path, location.origin);
 if (url.origin !== location.origin) throw new Error('Invalid styling source');
 const preview = new URL(location.href).searchParams.get('preview_theme_id');
 if (preview) url.searchParams.set('preview_theme_id', preview);
 else if (window.Shopify?.designMode && theme) url.searchParams.set('preview_theme_id', theme);
 return url;
}
async function load(root) {
 const url=themed(root.dataset.source,root.dataset.theme);
 const doc=await read(url);
 const grid=doc.querySelector('.styling-index__grid');
 if(!grid)throw new Error('Styling index is unavailable');
 return {cards:Array.from(grid.querySelectorAll('[data-central-look]')),failed:false,fresh:true};
}

const subscribers = new Set();
const cacheKey = root => '1618-styling-v3|' + root.dataset.theme + '|' + root.dataset.root + '|' + document.documentElement.lang;
function saved(root) {
 try {
  const data=JSON.parse(sessionStorage.getItem(cacheKey(root)));
  if(data && Array.isArray(data.html) && Date.now()-data.time < 60000) {
   return {cards:data.html.map(html=>parse(html).querySelector('.ss-card')).filter(Boolean),failed:false};
  }
 } catch {}
 return null;
}
function observe(root, callback) {
 subscribers.add(callback);
 const cached=saved(root);
 if(cached?.cards.length)callback(cached);
 if(!shared)shared=load(root).then(result=>{
  if(!result.failed) {
   try {sessionStorage.setItem(cacheKey(root),JSON.stringify({time:Date.now(),html:result.cards.map(card=>card.outerHTML)}));} catch {}
  }
  subscribers.forEach(fn=>fn(result));
  return result;
 }).catch(error=>{
  console.warn('Staff styling index:',error.message);
  subscribers.forEach(fn=>fn({cards:[],failed:true}));
 });
 else shared.then(result=>callback(result)).catch(()=>{});
 return ()=>subscribers.delete(callback);
}
function staffName(card) {
 const name = card.querySelector('.ss-name')?.cloneNode(true);
 name?.querySelectorAll('small').forEach(node => node.remove());
 return name?.textContent.trim() || 'STAFF';
}
function portalImage(original) {
 const image=original.cloneNode(true);
 image.removeAttribute('id');
 image.loading='lazy';
 image.sizes='(min-width:1440px) 440px, (min-width:750px) 33vw, 50vw';
 return image;
}
class StylingIndex extends HTMLElement {
 connectedCallback() {
  if(this.loaded)return;this.loaded=true;
  const grid=this.querySelector('.styling-index__grid');
  const select=this.querySelector('select');
  const update=()=>{
   let count=0;
   grid.querySelectorAll('.ss-card').forEach(card=>{card.hidden=!!select.value && card.dataset.staff!==select.value;if(!card.hidden)count++;});
   this.querySelector('.styling-index__count').textContent=count+' LOOKS';
  };
  select.addEventListener('change',update);
  const render=({cards,failed,fresh})=>{
   this.dataset.stylingState=fresh?'updated':'cached';
   if(cards.length || !failed) {
    const selected=select.value;
    const names=new Set();
    grid.replaceChildren();
    select.replaceChildren(new Option('ALL STAFF',''));
    for(const original of cards) {
     const card=original.cloneNode(true);
     card.removeAttribute('data-shopify-editor-block');
     card.dataset.staff=staffName(card);
     names.add(card.dataset.staff);
     card.querySelectorAll('.ss-media img').forEach(image=>{image.loading='lazy';image.sizes='(min-width:1440px) 440px, (min-width:750px) 33vw, 50vw';});
     grid.append(card);
    }
    for(const name of names)select.append(new Option(name,name));
    if(names.has(selected))select.value=selected;
    update();
   }
   const status=this.querySelector('.styling-index__status');
   status.hidden=grid.childElementCount>0;
   status.textContent=failed?'スタイリングを読み込めませんでした。ページを再読み込みしてください。':'スタイリングは準備中です。';
  };
  render({cards:Array.from(grid.querySelectorAll('.ss-card')),failed:false});
  // The index is rendered directly from the central registry by Liquid.

 }
 disconnectedCallback(){this.stop?.();this.loaded=false;}
}
class StylingPortal extends HTMLElement {
 connectedCallback() {
  if(this.loaded)return;this.loaded=true;
  const photos=this.querySelector('.styling-portal__photos');
  const initial=photos.querySelectorAll('img').length;
  if(initial)photos.style.gridTemplateColumns='repeat('+Math.min(3,initial)+',minmax(0,1fr))';
  this.stop=observe(this,({cards,failed,fresh})=>{
   this.dataset.stylingState=fresh?'updated':'cached';
   if(!cards.length){if(!failed)photos.replaceChildren();return;}
   photos.replaceChildren();
   photos.style.gridTemplateColumns='repeat('+Math.min(3,cards.length)+',minmax(0,1fr))';
   cards.slice(0,3).forEach(card=>photos.append(portalImage(card.querySelector('.ss-media img'))));
  });
 }
 disconnectedCallback(){this.stop?.();this.loaded=false;}
}
class StylingProduct extends HTMLElement {
 connectedCallback(){
  if(this.loaded)return;this.loaded=true;
  const pid=this.dataset.product;
  const categories=(this.dataset.collections||'').split('|').filter(Boolean);
  this.stop=observe(this,({cards,failed})=>{
   if(failed)return;
   const matches=cards.filter(card=>card.dataset.products?.includes('|'+pid+'|') || categories.some(id=>card.dataset.collections?.includes('|'+id+'|')));
   const grid=this.querySelector('.styling-index__grid');grid.replaceChildren();
   matches.forEach(card=>{const clone=card.cloneNode(true);clone.removeAttribute('data-shopify-editor-block');grid.append(clone);});
   this.hidden=!matches.length;
  });
 }
 disconnectedCallback(){this.stop?.();this.loaded=false;}
}
customElements.define('staff-styling-product',StylingProduct);
customElements.define('staff-styling-index',StylingIndex);
customElements.define('staff-styling-portal',StylingPortal);
})();